var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6e52b5745df839ed22850aa9a3d829aef6ba74c3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@hivemanager"]={id:"6e52b5745df839ed22850aa9a3d829aef6ba74c3"};
      